(() => {
  'use strict';
  const banner = document.querySelector('[data-selektad-banner]');
  if (!banner || banner.dataset.initialized) return;
  banner.dataset.initialized = 'true';
  // Keep previous popup dismissals, and isolate draft previews from live preferences.
  const preview = window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main';
  const key = 'toi-selektad-2026-promo' + (preview ? '-preview' : '');
  const expiry = Date.parse('2026-12-12T06:00:00+07:00');
  const week = 7 * 24 * 60 * 60 * 1000;
  const read = (storage) => {
    try { return window[storage].getItem(key); } catch (_) { return null; }
  };
  const save = (storage, value) => {
    try { window[storage].setItem(key, value); } catch (_) { /* Storage is optional. */ }
  };
  const dismiss = () => {
    save('localStorage', String(Date.now() + week));
    save('sessionStorage', 'dismissed');
    banner.hidden = true;
  };
  banner.querySelector('[data-selektad-close]').addEventListener('click', dismiss);
  banner.querySelector('[data-selektad-join]').addEventListener('click', dismiss);
  // Escape only applies while focus is within the banner; never capture shopping keys.
  banner.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); dismiss(); }
  });
  const showWhenIdle = () => {
    if (!banner.isConnected || Date.now() >= expiry || read('sessionStorage') === 'dismissed' || Number(read('localStorage')) > Date.now()) return;
    const active = document.activeElement;
    const busy = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], details[open]'))
      .some(element => element.getClientRects().length && window.getComputedStyle(element).visibility !== 'hidden');
    if (document.hidden || busy ||
        (active && active.matches('input, textarea, select, [contenteditable="true"]'))) {
      window.setTimeout(showWhenIdle, 2000);
      return;
    }
    banner.hidden = false;
  };
  // No dialog, focus movement, backdrop, scroll lock or page-wide click handler.
  window.setTimeout(showWhenIdle, 1500);
})();
